// Dependencies
var _ = require('underscore');
var Marionette = require('backbone.marionette');

// App
var controller = new (require('app/public-app/apps/controller'))();

var API = {
    agentListingDetail: function() {
        var args = _.initial(arguments);
        controller.listingDetail(args, window.location.search, 'agent');
    },
    agentListingDetailHex: function() {
        var rawArgs = _.initial(arguments);
        // convert first 3 args from hex and keep last 2 (location visibility and hash) as is
        var args = rawArgs.map((arg, idx, arr) => (idx < arr.length - 2 ? parseInt(arg, 16) : arg));
        controller.listingDetail(args, window.location.search, 'agent');
    },
    companyListingDetail: function() {
        var args = _.initial(arguments);
        controller.listingDetail(args, window.location.search, 'company');
    },
    agentBuildingDetail: function() {
        var args = _.initial(arguments);
        controller.buildingDetail(args, window.location.search, 'agent');
    },
    companyBuildingDetail: function() {
        var args = _.initial(arguments);
        controller.buildingDetail(args, window.location.search, 'company');
    },
};

var Router = Marionette.AppRouter.extend({
    controller: API,
    appRoutes: {
        'p/listing/:companyId/:unitId/:locationVisibility/:listingHash(/)': 'companyListingDetail',
        'p/listing/:companyId/:unitId/:agentId/:locationVisibility/:listingHash(/)': 'agentListingDetail',
        'p/listing/h/:companyId/:unitId/:agentId/:locationVisibility/:listingHash(/)': 'agentListingDetailHex',
        'p/building/:companyId/:buildingId/:locationVisibility/:buildingHash(/)': 'companyBuildingDetail',
        'p/building/:companyId/:buildingId/:agentId/:locationVisibility/:buildingHash(/)': 'agentBuildingDetail',
    },
});

module.exports = Router;
